import moment from "moment";
import { store } from "../../../../../config/store";
import { openCloseToast } from "../../../../Global/actions";
import trace from "../../../../../helpers/trace";
import helper from "../../../../../helpers/validaciones";
import { numberToDay } from "../../../../../helpers/strings";
import { showToastError, showToastSuccess } from "../../../../Main/actions";

import {
  GetOfficeAchs,
  getAllBlockingsWeek,
  GetAllBlockingsMonth,
  createdBlocking,
  getAllQuotes,
  deleteBlockingById,
  GetCenterConfiguration,
  getConfigurationById,
  getAllConfigurationList,
  updateBlocking,
  GetOpeningData,
  loadingBlockReason
} from "../../../../../services/bloqueos";
import constants from "../../../../../helpers/constants";


import { GetExcelSiniestrosApi } from "../../../../../services/SiniestrosEmpresa";
import FileSaver from "file-saver";
import { async } from "q";


export const loading = (isLoading) => ({
  type: "LOADING_BLOQUEOS_SCHEDULER",
  isLoading,
});

export const modalWizardLoading = (isModalWizardLoading) => ({
  type: "LOADING_BLOQUEO_MODAL_WIZARD",
  isModalWizardLoading,
});

export const setCenterList = (centrosList) => ({
  type: "SET_CENTER_LIST_BLOQUEOS",
  centrosList,
});
export const setAppointmentBlockingsList = (list) => ({
  type: "SET_APPOINTMENT_BLOCKINGS_LIST",
  list,
});
export const openCloseModalDeleteBlocking = (isOpen, data) => ({
  type: "OPEN_CLOSE_MODAL_DELETE_BLOCKING",
  isOpen,
  data,
});
export const setCenterConfig = (config) => ({
  type: "SET_CENTER_CONFIG_BLOCKING",
  config,
});
export const setConfiguration = (list) => ({
  type: "SET_CONFIGURATION",
  list,
});
export const setListWorkingDays = (listDaysWorking) => ({
  type: "SET_LIST_WORKING_DAYS",
  listDaysWorking,

});
export const openCloseModalConflictWeek = (isOpen) => ({
  type: "OPEN_CLOSE_MODAL_CONFLICT_WEEK",
  isOpen,
});
export const setListExamPool = (listExamPools) => ({
  type: "SET_LIST_EXAM_POOL",
  listExamPools,
});
export const setListExams = (listExams) => ({
  type: "SET_LIST_EXAMS",
  listExams,
});
export const setQuoteList = (listQuotes) => ({
  type: "SET_QUOTES_LIST",
  listQuotes,
});
export const setAppointmentApertura = (data) => ({
  type: "SET_APPOINTMENT",
  data,
});

export const openCloseModalEditWeek = (isOpen, data) => ({
  type: "OPEN_CLOSE_MODAL_EDIT_WEEK",
  isOpen,
  data,
});

export const setCenterIdBlocking = (centerId) => ({
  type: "SET_CENTER_ID_BLOCKING",
  centerId,
});

export const setListExamsCiel = (listCiel) => ({
  type: "SET_LIST_EXAMS_CIEL",
  listCiel,

});
export const setHideShowWizard = (value) => ({
  type: "SET_HIDE_SHOW_WIZARD_BLOCK",
  isPopupWizardOpen: value,
});

export const setStepWizard = (steps) => ({
  type: "SET_STEPS_WIZARD",
  steps,
});
export const setConfigShedulerWizard = (configSchedulerWizard) => ({
  type: "SET_CONFIG_SCHEDULER_WIZARD",
  configSchedulerWizard,
});

export const setBlocking = (blocking) => ({
  type: "SET_BLOCKING",
  blocking,
});
export const setWeekAppointments = (list) => ({
  type: "SET_WEEK_APPOINTMENTS",
  list,
});
export const setAppointmentEditWeek = (data) => ({
  type: "SET_APPOINTMENT_EDIT_WEEK",
  data,
});
export const resetBlockingState = (centerId) => ({
  type: "RESET_BLOCKING_STATE",
  centerId,
});

export const setFeriadosAdminAperturas = (feriados) => ({
  type: "SET_FERIADOS_ADMIN_BLOQUEOS",
  feriados,
});
export const setValidationBlocking = (validationBlocking) => ({
  type: "SET_VALIDATION_BLOCKING",
  validationBlocking,
});

export const setIsDownloadExcel = (isDownloadExcel) => ({
  type: "SET_DOWNLOAD_EXCEL_BLOCKING",
  isDownloadExcel,
});
export const setNameConflictModal = (isModalNameAndConflictOpen) => ({
  type: "SET_OPEN_CONFLICT_OPEN",
  isModalNameAndConflictOpen,
});
export const resetState = () => ({
  type: "RESET_STATES_BLOCKING"
})

export const setDataPage = (page) => ({
  type: "SET_DATA_PAGE_MATRIZ",
  page
})

export const setOpeningData = (data) => ({
  type: "SET_OPENING_DATA_BLOCKING",
  data
})

export const setBlockReasonList = (data) => ({
  type: "SET_BLOCK_REASON_DATA",
  data
})

export const doGetCenters = () => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetOfficeAchs();
    const result = await request.json();
    if (request.status === 200) {
      const centrosList = result.filter((o) => o.Status === 1);
      dispatch(setCenterList(centrosList.sort((a, b) => a.Description - b.Description)));
      dispatch(doGetCenterConfiguration(centrosList[0].Id));
      dispatch(setCenterIdBlocking(centrosList[0].Id));
      //dispatch(doGetWeekAppointments(centrosList[0].Id));
      dispatch(doGetBlockingsAppointments(centrosList[0].Id));
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetCenters", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetOpeningData = (center, start, end) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await GetOpeningData(center, start, end);
    const result = await request.json();
    if (request.status === 200) {
      dispatch(setOpeningData(result))
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetOpeningData", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doEditOpeningData = (blocking) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const center = blocking.OfficeId;
    const startEnd = moment(blocking.BlockDate).format("YYYY-MM-DD");
    const request = await GetOpeningData(center, startEnd, startEnd);
    const result = await request.json();
    if (request.status === 200) {
      let newBlocking = {};
      newBlocking.Id = blocking.Id;
      newBlocking.NameBlocking = blocking.BlockName;
      newBlocking.startDate = blocking.BlockDate;
      newBlocking.endDate = blocking.BlockDate;
      newBlocking.pagerStartDate = blocking.BlockDate;
      newBlocking.BlockingReasonId = blocking.BlockingReasonId;
      newBlocking.comment = blocking.BlockComment;
      newBlocking.BlockAll = blocking.BlockAll;
      const pivot = helper.getDaysByOrder(moment(blocking.BlockDate).format("E"));
      newBlocking.priorityData = [{
        text: helper.capitalizeFirstLetter(pivot.name),
        id: pivot.index,
        order: pivot.order,
        date: blocking.BlockDate
      }];
      let data = [];
      const concatDateAndTime = (date, time) => {
        const soloFecha = moment(new Date(date), "DD-MM-YYYY").format("DD-MM-YYYY");
        const soloHora = moment(time, "HH:mm").format("HH:mm");
        const fechaHora = `${soloFecha} ${soloHora}`;
        return new Date(moment(fechaHora, "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm"));
      }
      newBlocking.priorityData.forEach((item) => {
        data = [...data, ...result.map(e => {
          let start = concatDateAndTime(item.date, moment(e.StartTime, "HH:mm:ss").format("HH:mm"));
          let end = concatDateAndTime(item.date, moment(e.EndTime, "HH:mm:ss").format("HH:mm"));
          let _quota = e.BlocDateDetails.find(ee => moment(ee.SchedulingDate).isSame(moment(item.date).startOf("day")))
          return {
            day: item.order || (item.id === 0 ? 7 : item.id),
            startDate: start,
            endDate: end,
            startDateInt: start.setHours(moment(start).hour(), moment(start).minutes(), 0, 0),
            endDateInt: end.setHours(moment(end).hour(), moment(end).minutes(), 0, 0),
            Quotas: _quota ? _quota.OpeningQuotaDetails : null,
          };
        })]
      })
      newBlocking.data = data;
      newBlocking.completeData = [data];
      newBlocking.timeStep = result[0].ModuleDuration;
      newBlocking.dataPage = 0;
      newBlocking.dataPageLength = 0;
      newBlocking.isNewConfig = false;

      const getTimeAsFloat = (time, isMax) => {
        let totalHour = isMax ? parseInt(moment.max(time).format("HH")) : parseInt(moment.min(time).format("HH"));
        const minutes = isMax ? parseInt(moment.max(time).format("mm")) : parseInt(moment.min(time).format("mm"));

        if (minutes === 15) { totalHour += 0.25; }
        if (minutes === 30) { totalHour += 0.5; }
        if (minutes === 45) { totalHour += 0.75; }
        return totalHour;
      }

      const momentsMax = newBlocking.data.map((d) => moment(d.endDate));
      const momentsMin = newBlocking.data.map((d) => moment(d.startDate));
      const config = {
        startDayHour: getTimeAsFloat(momentsMin, false),
        endDayHour: getTimeAsFloat(momentsMax, true),
        cellDuration: parseInt(newBlocking.timeStep, 10),
      };
      dispatch(setConfigShedulerWizard(config));
      await dispatch(setBlocking(newBlocking));
      dispatch(setStepWizard({
        stepOne: true,
        stepTwo: false,
        stepThree: false,
        stepFour: false,
        stepSuccess: false,
      }));
      dispatch(setHideShowWizard(true));
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doEditOpeningData", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetCenterConfiguration = (IdCentro) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const config = {};
    const blocking = {};
    const request = await GetCenterConfiguration(IdCentro);
    const response = await request.json();
    if (request.status === 200) {
      const Days = helper.getUnique(response.Days, "DayId").map(e => {if(e.DayId === 7) e.DayId = 0; return e});
      const pivotDays = Days.map((d) => ({ day: numberToDay(d.DayId), since: d.Since, until: d.Until }));
      const sat = pivotDays.find((s) => s.day === constants.sabado); //! == undefined;
      const sun = pivotDays.find((s) => s.day === constants.domingo); // !== undefined;
      const week = pivotDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo);

      const workDays = [];
      pivotDays.forEach((item) => {
        const pivot = helper.getDaysIndex(item.day);
        workDays.push({ index: pivot.index, day: pivot.name, order: pivot.order });
      });
      const ExamPools = helper.getUnique(response.Pools.map((p) => ({ id: p.PoolId, Name: p.Description })), "Name");
      const Exams = helper.getUnique(response.AdditionalExams.map((exam) => ({ id: exam.ExamId, Name: exam.Description })), "Name");
      const Ciel = helper.getUnique(response.PsychologicalExams.map((c) => ({ id: c.ExamId, Name: c.Description })), "Name");

      blocking.IdCentro = response.Id;
      blocking.Id = 0;
      blocking.IdConfig = 0;
      blocking.weekWorking = false;
      blocking.isNewConfig = true;
      blocking.workDays = [];
      blocking.dataPage= 0;
      blocking.dataPageLength= 0;
      blocking.BlockAll= false;
      blocking.data = [];
      blocking.completeData = [];
      blocking.timeStep = 30

      config.canOverBookCiel = response.CielOverbook;
      config.maxOverBookCiel = response.CielOverbookedMaximumAmount;
      config.canOverBookOcupational = response.OccupationalOverbook;
      config.maxOverBookOcupational = response.OccupationalOverbookedMaximumAmount;
      config.canOverBookPreocupational = response.WorryingOverbook;
      config.maxOverBookPreocupational = response.WorryingOverbookedMaximumAmount;

      config.minWorkDay = week !== undefined ? week.since : null;
      config.maxWorkDay = week !== undefined ? week.until : null;

      config.minSatWork = sat !== undefined ? sat.since : null;
      config.maxSatWork = sat !== undefined ? sat.until : null;

      config.minSunWork = sun !== undefined ? sun.since : null;
      config.maxSunWork = sun !== undefined ? sun.until : null;
      config.listCiel = Ciel;
      config.listDaysWorking = workDays.sort((a, b) => a.order - b.order);
      config.listExamPools = ExamPools;
      config.listExams = Exams;

      dispatch(setCenterConfig(config));
      dispatch(setBlocking(blocking));
    } else if (request.status === 400) {
      dispatch(showToastError(request.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetCenterConfiguration:>", error);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};
export const doGetListConfigurations = (IdCentro) => async (dispatch) => {
  try {
    const request = await getAllConfigurationList(IdCentro);
    const response = await request.json();
    const list = response.map((p) => ({ IdConfig: p.Id, NameConfig: p.Description }));
    list.push({ IdConfig: 0, NameConfig: "Nueva" });
    dispatch(setConfiguration(list.sort((a, b) => a.IdConfig - b.IdConfig)));
  } catch (error) {
    trace.error("doGetListConfigurations", error);
    dispatch(showToastError());
  }
};
export const doGetConfigurations = (blocking, IdConfig) => async (dispatch) => {
  dispatch(modalWizardLoading(true));
  try {
    // solo busco las configuraciones

    const newBlocking = blocking;
    const request = await getConfigurationById(IdConfig);
    const config = await request.json();
    if (request.status === 200) {
      let pivotDays = config.WorkingDaysString.split(",");

      pivotDays = pivotDays.map((d) => {
        const day = numberToDay(parseInt(d, 10));
        const pivot = helper.getDaysIndex(day);
        return { index: pivot.index, day: pivot.name, order: pivot.order };
      });
      const workDays = pivotDays.map((d) => ({ index: d.index, day: d.day }));

      newBlocking.weekWorking = pivotDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo) !== undefined;
      newBlocking.satWorking = pivotDays.find((s) => s.day === constants.sabado) !== undefined;
      newBlocking.sunWorking = pivotDays.find((s) => s.day === constants.domingo) !== undefined;

      newBlocking.IdConfig = IdConfig;
      newBlocking.isNewConfig = false;

      newBlocking.startWorkDay = newBlocking.weekWorking ? config.StartTime : null;
      newBlocking.endWorkDay = newBlocking.weekWorking ? config.EndTime : null;

      newBlocking.satWorkstart = newBlocking.satWorking ? config.StartTimeSaturday : null;
      newBlocking.satWorkEnd = newBlocking.satWorking ? config.EndTimeSaturday : null;

      newBlocking.sunWorkStart = newBlocking.sunWorking ? config.StartTimeSunday : null;
      newBlocking.sunWorkEnd = newBlocking.sunWorking ? config.EndTimeSunday : null;

      newBlocking.moduleTime = config.ModuleDuration;

      newBlocking.NameBlocking = config.Description;
      newBlocking.ExamPools = config.Pools.map((p) => p.Id);
      newBlocking.Exams = config.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id);
      newBlocking.Ciel = config.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id);
      newBlocking.workDays = workDays;
      newBlocking.data = config.Modules;

      dispatch(setBlocking(newBlocking));
    } else if (request.status === 400) {
      dispatch(showToastError(config.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    trace.error("doGetDataToUpdateBlocking", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(modalWizardLoading(false));
};

export const doGetBlockingsAppointments = (centerId, start) => async (dispatch) => {
  if (!centerId) return;
  dispatch(loading(true));
  try {
    const startDate = moment(start).startOf("months");
    const endDate = moment(start).endOf("months").add(1, "day");

    const request = await GetAllBlockingsMonth(centerId, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setAppointmentBlockingsList(result.map((item) => ({
        ...item,
        text: item.BlockName,
        startDate: new Date(item.BlockDate),
        endDate: new Date(item.BlockEndDate),
      }))));
    } else if (request.status === 400) {
      const result = await request.json();
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (error) {
    dispatch(loading(false));
    trace.error("doGetBlockingsAppointments", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
};

export const doGetQuotesList = () => async (dispatch) => {
  try {
    const request = await getAllQuotes();
    if (request.status === 200) {
      const result = await request.json();
      const list = [];
      result.forEach((q) => {
        const Quota = {
          Id: q.Id,
          Description: q.Description,
          Overbook: q.Overbook,
          OverbookedMaximumAmount: q.OverbookedMaximumAmount,
          Status: q.Status,
        };
        list.push({
          AmmountQuota: 0,
          AmmountOverQuota: 0,
          Quota,
        });
      });

      dispatch(setQuoteList(list));
    } else {
      dispatch(loading(false));
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error cargar lista de cupos",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    trace.error("doGetQuotesList", e);
    dispatch(showToastError());
  }
};

export const doGetWeekAppointments = (centerId, start) => async (dispatch) => {
  if (!centerId) return;
  dispatch(loading(true));
  try {
    const startDate = moment(start).startOf("isoweek");
    const endDate = moment(start).endOf("isoWeek");

    const request = await getAllBlockingsWeek(centerId, startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"));
    const result = await request.json();
    if (request.status === 200) {
      dispatch(setWeekAppointments(result.map((item) => ({
        ...item,
        startDate: new Date(new Date(item.StartDatetime).setHours(moment(item.StartDatetime).format("HH"), moment(item.StartDatetime).format("mm"), 0, 0)),
        endDate: new Date(new Date(item.EndDatetime).setHours(moment(item.EndDatetime).format("HH"), moment(item.EndDatetime).format("mm"), 0, 0)),
      }))));
    } else if (request.status === 400) {
      dispatch(showToastError(result.Message));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("doGetWeekAppointments", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doUpdateWeekAppointment = (data) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const dayOfModule = new Date(data.StartDatetime).getDay();
    const startTime = moment(data.StartDatetime).format("HH:mm");
    const endTime = moment(data.EndDatetime).format("HH:mm");
    const newConfig = {
      EndDate: data.EndDatetime,
      StartDate: data.StartDatetime,
      Id: 0,
      Configuration: {
        Center: data.config.Center,
        Description: data.config.Description,
        Exams: data.config.Exams.map((Id) => ({ Id })),
        Pools: data.config.Pools.map((Id) => ({ Id })),
        Ciel: data.config.Ciel.map((Id) => ({ Id })),
        Id: 0,
        ModuleDuration: data.config.ModuleDuration,
        Modules: [{
          Day: dayOfModule,
          StartTime: startTime,
          EndTime: endTime,
          Quotas: data.Quotas.map((q) => ({
            AmmountOverQuota: q.AmmountOverQuota,
            AmmountQuota: q.AmmountQuota,
            Quota: q.Quota,
          })),
        }],
        StartTime: dayOfModule < 5 ? startTime : null,
        EndTime: dayOfModule < 5 ? endTime : null,
        StartTimeSaturday: dayOfModule > 4 ? startTime : null,
        EndTimeSaturday: dayOfModule > 4 ? endTime : null,
        StartTimeSunday: dayOfModule > 4 ? startTime : null,
        EndTimeSunday: dayOfModule > 4 ? endTime : null,
        WorkingDays: [dayOfModule],
      },
    };

    const request = await createdBlocking(newConfig);

    if (request.status === 200) {
      dispatch(showToastSuccess(`Se han editado los cupos del ${moment(data.startDate).format("dddd")} a las ${moment(data.startDate).format("HH:mm")}`));
      dispatch(openCloseModalEditWeek(false, { config: {} }));
      dispatch(openCloseModalConflictWeek(false));

      const state = store.getState().bloqueosSel;
      dispatch(doGetBlockingsAppointments(state.centerId, data.startDate));
      dispatch(doGetWeekAppointments(state.centerId, data.StartDate));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 406) {
      const response = await request.json();
      dispatch(setValidationBlocking({
        quotes: response.QuotaInConflict,
        openValidation: true,
        message: response.Message,
      }));
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("doUpdateWeekAppointment", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doCreateUpdateBlocking = (blocking) => async (dispatch) => {
  dispatch(loading(true));
  try {
    let request = {};

    let msg;
    if (blocking.Id === null || blocking.Id === 0) {
      request = await createdBlocking(blocking);
      msg = "Creación de Apertura realizada";
    } else {
      request = await updateBlocking(blocking);

      msg = "Modificación de Apertura realizada";
    }
    if (request.status === 200) {
      dispatch(showToastSuccess(msg));
      dispatch(setHideShowWizard(false));
      const state = store.getState().bloqueosSel;
      dispatch(doGetBlockingsAppointments(state.centerId));
      dispatch(doGetWeekAppointments(state.centerId));
      dispatch(resetBlockingState(state.centerId));
      dispatch(setValidationBlocking({
        quotes: 0,
        openValidation: false,
      }));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 500) {
      dispatch(showToastError());
    } else if (request.status === 406) {
      const response = await request.json();
      dispatch(setValidationBlocking({
        quotes: response.QuotaInConflict,
        openValidation: true,
        message: response.Message,
      }));
      dispatch(setNameConflictModal(true));
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("doCreateUpdateBlocking", e);
    dispatch(showToastError());
  }
  dispatch(loading(false));
};

export const doGetDataToUpdateBlocking = (opSelected, centerId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const blocking = {};
    const IdConfig = opSelected.Configuration.Id;
    const request = await getConfigurationById(IdConfig);
    const config = await request.json();

    let pivotDays = opSelected.Configuration.WorkingDaysString.split(",");
    pivotDays = pivotDays.map((d) => {
      const day = numberToDay(parseInt(d, 10));
      const pivot = helper.getDaysIndex(day);
      return { index: pivot.index, day: pivot.name, order: pivot.order };
    });
    const workDays = pivotDays.map((d) => ({ index: d.index, day: d.day }));
    blocking.Id = opSelected.Id;
    blocking.IdConfig = IdConfig;
    blocking.IdCentro = centerId;
    blocking.isNewConfig = false;
    blocking.startDate = opSelected.StartDate;
    blocking.endDate = opSelected.EndDate;
    blocking.pagerStartDate = opSelected.StartDate;

    blocking.satWorking = pivotDays.find((s) => s.day === constants.sabado) !== undefined;
    blocking.sunWorking = pivotDays.find((s) => s.day === constants.domingo) !== undefined;
    blocking.ExamPools = config.Pools ? config.Pools.map((p) => p.Id) : [];
    blocking.Exams = config.Exams ? config.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id) : [];
    blocking.Ciel = config.Exams ? config.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id) : [];
    blocking.weekWorking = workDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo) !== undefined;
    blocking.startWorkDay = blocking.weekWorking ? config.StartTime : null;
    blocking.endWorkDay = blocking.weekWorking ? config.EndTime : null;
    blocking.satWorkstart = blocking.satWorking ? config.StartTimeSaturday : null;
    blocking.satWorkEnd = blocking.satWorking ? config.EndTimeSaturday : null;
    blocking.sunWorkStart = blocking.sunWorking ? config.StartTimeSunday : null;
    blocking.sunWorkEnd = blocking.sunWorking ? config.EndTimeSunday : null;

    blocking.moduleTime = config.ModuleDuration;
    blocking.NameBlocking = config.Description;
    blocking.workDays = workDays;
    blocking.data = config.Modules;
    await dispatch(setBlocking(blocking));
    dispatch(setStepWizard({
      stepOne: true,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepSuccess: false,
    }));
    dispatch(setHideShowWizard(true));
  } catch (error) {
    trace.error("doGetDataToUpdateBlocking", error);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente mas tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }

  dispatch(loading(false));
};

export const doDeleteBlockingById = (id, connectionHub) => async (dispatch) => {
  dispatch(loading(true));
  try {
    await connectionHub.invoke("DeleteBlock", id)
  } catch (e) {
    dispatch(loading(false));
    trace.error("doDeleteBlockingById", e);
    dispatch(showToastError());
  }
};

export const doGetDataToUpdateWeek = (appointment) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await getConfigurationById(appointment.ConfigurationId);
    if (request.status === 200) {
      const result = await request.json();

      const data = {
        ...appointment,
        config: {
          ...result,
          Pools: result.Pools.map((i) => i.Id),
          Ciel: result.Exams.filter((i) => i.ExamTypeId === 2).map((i) => i.Id),
          Exams: result.Exams.filter((i) => i.ExamTypeId === 1).map((i) => i.Id),
        },
      };
      dispatch(openCloseModalEditWeek(true, data));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("doGetDataToUpdateWeek", e);
    showToastError();
  }
  dispatch(loading(false));
};

export const doGetFeriadosAdmin = (centerId) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const feriados = [
      new Date(2019, 6, 24),
    ];
    dispatch(setFeriadosAdminAperturas(feriados));
  } catch (e) {
    dispatch(loading(false));
    trace.error("doGetFeriadosAdmin", e);
    showToastError();
  }
  dispatch(loading(false));
};

export const doGetExcel = () => async (dispatch) => {
  dispatch(setIsDownloadExcel(true));
  try {
    const header = {
      RutEmpresa: "70360100-6",
      Pagina: 1,
      RegistrosPorPagina: 100000,
      FechaPresentacionInicio: 20180613,
      FechaPresentacionFin: 20190613,
    };
    const request = await GetExcelSiniestrosApi(header);
    if (request !== 0) {
      const file = new Blob([request], { type: "application/xls;base64" });
      FileSaver.saveAs(file, "documento.xlsx");
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error en descargar archivo",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("doGetExcel", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión, intente más tarde",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(setIsDownloadExcel(true));
};

export const createBlock = (arr, connectionHub) => async (dispatch) =>{
  dispatch(loading(true))
  try {
    await connectionHub.invoke("CreateBlock", arr);
  } catch (e) {
    dispatch(loading(false));
    trace.error("createBlock", e);
    dispatch(showToastError());
  }
}

export const editBlock = (arr, connectionHub) => async (dispatch) =>{
  dispatch(loading(true))
  try {
    await connectionHub.invoke("UpdateBlock", arr);
  } catch (e) {
    dispatch(loading(false));
    trace.error("editBlock", e);
    dispatch(showToastError());
  }
}

export const deleteBlock = (id, connectionHub) => async (dispatch) => {
  dispatch(loading(true));
  try {
    await connectionHub.invoke("DeleteBlock", id)
  } catch (e) {
    dispatch(loading(false));
    trace.error("doDeleteBlockingById", e);
    dispatch(showToastError());
  }
};

export const loadBlockReason = () => async(dispatch) => {
  try{
    const request = await loadingBlockReason();
    if (request.status === 200) {
      const result = await request.json();
      dispatch(setBlockReasonList(result));
    } else if (request.status === 400) {
      dispatch(showToastError());
    } else if (request.status === 500) {
      dispatch(showToastError());
    }
  } catch (e) {
    dispatch(loading(false));
    trace.error("loadBlockReason", e);
    dispatch(showToastError());
  }
}
